import { sInputKeyValidationHelper } from "../../shared.min.js";

//GENERIC WIDGET CONTROLS & HELPER FUNCTIONS
const widgetControlls = {
	widget: null,
	widgetSteps: [],
	currentWidgetStep: 1,
	totalWidgetSteps: 0,

	widgetBanner: {
		banner: null,
		progressBar: null,
		totalStep: null,
		currentStep: null,
		title: null,
		progressBarStepLength: 0
	},

	init(widget) {
		if (!widget) return;

		this.widget = widget;
        this.widgetSteps = Array.from(this.widget.querySelectorAll('.widget__step'));
		
		//GET NODES FOR BANNER
		this.getWidgetBannerNodes();
		this.setTotalWidgetSteps();
		this.setBackButtonEListeners();
	},
	
	
	//WIDGET NAVIGATION
	showNewWidgetState() {
		//INCREMENT APP AND HIDE/SHOW NEW/PREV APP STEP
		if (!this.widgetSteps || this.widgetSteps.length === 0) return;

		//IF WIDGET STEPS IS EQUAL TO CURRENT WIDGET STEPS, SHOW STEP, ELSE HIDE
		this.widgetSteps.forEach((step, index) => this.toggleVisibility(step, index + 1 === this.currentWidgetStep));
		this.updateProgressBar();
	},

	setTotalWidgetSteps() {
		if (!this.widgetSteps) return;

		this.totalWidgetSteps = this.widgetSteps.length;
		this.setWidgetBanner(this.totalWidgetSteps);
	},

	setBackButtonEListeners() {
		const backButtons = widgetControlls.widget.querySelectorAll('.arrow-link--back');
		backButtons.forEach(button => button.addEventListener('click', (e) => widgetControlls.decrementWidgetStep(e)));
	},

	restartWidget(e) {
		e.preventDefault();
		this.currentWidgetStep = 1;
		this.showNewWidgetState();
	},

	decrementWidgetStep(e) {
		e?.preventDefault();
		if (this.currentWidgetStep !== 1) {
			this.currentWidgetStep -= 1;
			this.showNewWidgetState();
		}
	},

	incrementWidgetStep() {
		//RESET APP IF REACHES END ELSE
		if (this.currentWidgetStep < this.totalWidgetSteps) {
			this.currentWidgetStep += 1;
		} else {
			this.currentWidgetStep = 1;
		}
		this.showNewWidgetState();
	},


	//BANNER FUNCTIONALITY
	setWidgetBanner(numberOfWidgetSteps) {
		const { widgetBanner } = this;

		widgetBanner.progressBarStepLength = 100 / numberOfWidgetSteps;
		if (widgetBanner.totalStep) widgetBanner.totalStep.innerText = numberOfWidgetSteps;

		this.updateProgressBar();
	},


	getWidgetBannerNodes() {
		const { widget, widgetBanner } = this;

		if (!widget) return;
		
		widgetBanner.banner = widget.querySelectorAll('.widget__banner');
		widgetBanner.progressBar = widget.querySelector('.widget__banner__progress-bar__step');
		widgetBanner.currentStep = document.getElementById('banner-step-current');
		widgetBanner.totalStep = document.getElementById('banner-step-total');
		widgetBanner.title = document.querySelector('.widget__banner__header__title');
	},


	updateProgressBar() {
		const {widgetBanner, currentWidgetStep} = this;

		widgetBanner.progressBar.style.width = `${widgetBanner.progressBarStepLength * currentWidgetStep}%`;
		widgetBanner.currentStep.innerText = currentWidgetStep;

		this.setBannerTitle();

	},

	setBannerTitle() {
		const { widgetSteps, widgetBanner, currentWidgetStep } = this;

		const currentStep = widgetSteps[currentWidgetStep -1];
		widgetBanner.title.innerText = currentStep.getAttribute('data-step-name');
	},


	//VISIBILITY CONTROLLS
	
	toggleVisibility(element, show) {
		if (show) {
		  element.classList.remove('display-none');
		} else {
		  element.classList.add('display-none');
		}
	},


	//ERROR STATES

	setFieldErrorState(field) {
		field.classList.add('field-group--error');
	},

	removeErrorFromInput(field) {
		field.classList.remove('field-group--error');
	},

}




//HANDLES FUNCTIONALITY FOR QR GERNERATION

const lostLuggageQRGenerator = {
	qrCodeElement: null,
	qrCode: undefined,
	vCardText: '',
	tagInputValue: null,
	baseTagType: '',

	cardTextFallback: {
		luggage: "Consider placing it in the address holder that many cases come with.",
		phone: "Consider placing the tag in the back of your phone case or card holder.",
		key: "Consider placing the tag in a key ring holder.",
	},

	qrCodeData: {
		name: '',
		phone: '',
		email: '',
		note: ''
	},

	forms: {
		tagTypeForm: null,
		contactDetailsForm: null,
		noteForm: null
	},


	
	infoTipCard: null,

	init(qrGenerator) {
		
		//GET  ELEMENTS
		this.getWidgetNodes();

		//SET UP E-LISTENERS
		this.addFormSubmitListeners();

		//INPUT VALIDATION
		this.initiateInputValidation(qrGenerator);

		//DOWNLOAD PDF
		this.attachDownloadPDFHandler();

		//RESTARD WIDGET
		this.handleWidgetRestart();

		//IF FORM ISNT SET BY THE TAG FORM INPUT, SET AS BASE TAG TYPE FROM HTML
		if (!this.forms.tagTypeForm && this.baseTagType !== 'luggage') this.setTagTypeForPDF(this.baseTagType);

	},

	getWidgetNodes() {
		const {forms} = this;

		this.baseTagType = document.getElementById('cnfsd-wdgt-lost-luggage-base-tag-type')?.innerText || 'luggage';

		//GET FORMS
		if (this.baseTagType === 'luggage') forms.tagTypeForm = document.getElementById('cnfsd-wdgt-lost-luggage-tag-form');

		forms.contactDetailsForm = document.getElementById('cnfsd-wdgt-lost-luggage-details-form');

		forms.noteForm = document.getElementById('cnfsd-wdgt-lost-luggage-note-form');

		//GET QR CODE CONTAINER
		this.qrCodeElement = document.querySelector('.widget__step > .widget__qr-container');

		//GET CARD 
		this.infoTipCard = document.getElementById('cnfsd-wdgt-lost-luggage-qr-code-info-tip');
	},


	attachDownloadPDFHandler() {
		//DOWNLOAD QR CODE BUTTON
		const downloadQRCodeButton = document.getElementById('cnfsd-wdgt-lost-luggage-download-code');
		downloadQRCodeButton?.addEventListener('click', (e) => lostLuggagePDFBuilder.generatePDF(e));
	},


	handleWidgetRestart() {
		const restartWidgetButton = document.querySelector('.widget__restart');
		restartWidgetButton?.addEventListener('click', (e) => widgetControlls.restartWidget(e));
	},

	initiateInputValidation(qrGenerator) {
		//SET UP USER INPUT VALIDATION
		const allFields = qrGenerator.querySelectorAll('.field-group');
		this.setInputValidation(allFields);
	},

	addFormSubmitListeners() {
		const {forms} = this;

		const contactDetailFields = forms.contactDetailsForm?.querySelectorAll('.field-group') || [];
		if (forms.tagTypeForm) this.addTagFormListener(contactDetailFields);
		this.addContactFormListener(contactDetailFields);
		this.addNoteFormListener();
	},

	setTagTypeForPDF(tagType) {
		//SET THE TAG TYPE FOR USE IN PDF GENERATOR
		lostLuggagePDFBuilder.tagInputValue = tagType;
	},
		


	addTagFormListener(contactDetailFields) {
		const {forms} = this;

		const tagTypeInput = document.getElementById('cnfsd-wdgt-lost-luggage-tag-type');
		forms.tagTypeForm?.addEventListener('submit', (e) => {
			e.preventDefault();
			this.processTagTypeSubmission(tagTypeInput, contactDetailFields);
		});
	},

	addContactFormListener(contactDetailFields) {
		const {forms} = this;

		forms.contactDetailsForm?.addEventListener('submit', (e) => {
			e.preventDefault();
			this.processUserDataSubmission(contactDetailFields);
		});
	},

	addNoteFormListener() {
		const {forms} = this;

		const noteInput = document.getElementById('cnfsd-wdgt-lost-luggage-note');
		const noteInputCharCount = document.getElementById('cnfsd-wdgt-lost-luggage-note-charcount');

		noteInput.addEventListener('input', () => this.handleNoteInputCharCount(noteInput, noteInputCharCount, 200));

		forms.noteForm?.addEventListener('submit', (e) => {
			e.preventDefault();
			this.processNoteSubmission(noteInput);
		});
	},

	handleNoteInputCharCount(input, displayNode, totalCount) {
		const currentCharCount = input.value.length;
		const charCountLeft = totalCount - currentCharCount;

		//IF DOESN'T EXCEED TOTAL COUNT
		if (currentCharCount !== totalCount + 1) displayNode.innerText = `${charCountLeft} characters remaining`;
	},


	processNoteSubmission(noteInput) {
		const {qrCodeData, qrCodeElement} = this;

		//SET NOTE IN QR DATA TO NOTE INPUT VALUE
		qrCodeData.note = noteInput.value;
		
		//CREATE V CARD
		this.vCardText = this.createVCard();

		//RESET QR CODE IF ONE ALREADY EXISTS
		if (this.qrCode !== undefined) this.resetQRCode();
		
		this.qrCode = this.generateQRCode(qrCodeElement);
		//INCREMENT NAV STEP
		widgetControlls.incrementWidgetStep();
	},

	setInputValidation(fields) {
		fields.forEach(field => {
			const inputWithValidation = field.querySelector('input[data-input-validation]');
			if (inputWithValidation) {
				const inputValidationType = inputWithValidation.getAttribute('data-input-validation');
				sInputKeyValidationHelper(inputWithValidation, inputValidationType, field);
			}
		});
	},

	processTagTypeSubmission(tagTypeSelect, contactDetailFields) {
		const validInputTypes = this.parseSelectOptionInputs(tagTypeSelect);
		this.toggleContactFormInputs(contactDetailFields, validInputTypes);
		widgetControlls.incrementWidgetStep();
	},

	createVCard() {
		const { name, email, phone, note } = this.qrCodeData;

		const formattedNote = note.replace(/\n/g, '\\n');

		const vCardLines = [
			'BEGIN:VCARD',
			'VERSION:3.0',
			`FN:${name}`,
			phone ? `TEL;TYPE=CELL,VOICE:${phone}` : '',
			email ? `EMAIL:${email}` : '',
			note ? `NOTE:${formattedNote}` : '',
			'END:VCARD'
		];

		//FILTER ANY EMPTY LINES AND THEN JOIN THE REST
		return vCardLines.filter(line => line.trim() !== '').join('\n');
	},

	generateQRCode(element, width=142, height=142) {
		const {vCardText} = this;

		return new QRCode(element, {
			text: vCardText,
			width: width,
			height: height,
		});
	},

	resetQRCode(){
		const {qrCodeElement} = this;
		//REMOVE CURRENT QR BEFORE GENERATING A NEW ONE
		while (qrCodeElement.firstChild) {
			qrCodeElement.removeChild(qrCodeElement.firstChild);
		}
	}, 

	processUserDataSubmission(fields) {
		//CHECK INPUTS PASS VALIDATION
		const inputsFailed = this.validateContactFormInputValues(fields);

		//IF THERE ARE INPUTS WITH ERRORS, SHOW ERROR MESSAGE OF INPUT
		if (inputsFailed.length) {
			inputsFailed.forEach(field => {
				widgetControlls.setFieldErrorState(field);
			});
		} else {
			//GENERATE QR HERE
			widgetControlls.incrementWidgetStep();
		}
	},

	validateContactFormInputValues(fields) {
		//CONTACT FORM USER INPUT VALIDATION 
		const { qrCodeData } = this;

		let invalidFields = [];
		const validateField = (field) => {
			//IF FIELD IS HIDDEN (NOT USED IN VCARD), SET DATA BACK TO EMPTY STRING

			const input = field.querySelector('input');
			const value = input?.value.trim();
			const dataInputType = input?.getAttribute('data-input-type');

			if (field.classList.contains('display-none')) return qrCodeData[dataInputType] = '';

			//CHECK EACH FIELD TYPE 
			switch(dataInputType) {
				case 'name':
					if (!value) invalidFields.push(field);
					break;
				case 'email':
					const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!value || !regex.test(value)) invalidFields.push(field);
					break;
				case 'phone':
					const trimmedValue = value.replace(/\s+/g, '');
					if (!value || (trimmedValue.length !== 10 && trimmedValue.length !== 11)) invalidFields.push(field);
					break;
				default:
					if (!value) invalidFields.push(field);
					break;
			}

			// SET THE VALUE TO THE QR DATA IF VALID INPUT 
			if (!invalidFields.includes(field)) qrCodeData[dataInputType] = value;
		}

		fields.forEach(field => validateField(field));

		return invalidFields;
	},

	toggleContactFormInputs(contactDetailFields, validInputTypes) {
		contactDetailFields.forEach(field => {
			const input = field.querySelector('input');
			const inputType = input.getAttribute('data-input-type');

			if (validInputTypes.includes(inputType)) {
				widgetControlls.toggleVisibility(field, true);
			} else {
				widgetControlls.toggleVisibility(field, false);
			}
		})
	},

	handleTagSelection(selectedOption){
		const inputValue = selectedOption.dataset.inputValue;
		const qrInfoTipText = selectedOption.dataset.qrCodeInfoTip;

		//SET THE TAG TYPE FOR USE IN PDF GENERATOR
		this.setTagTypeForPDF(inputValue);

		//CHECKS IF INFO CARD TEXT HAS BEEN SET FROM CMS
		this.setCardText(qrInfoTipText);
	},

	parseSelectOptionInputs(tagTypeSelect) {
		//GET DATA ATTRIBUTE FROM OPTION SELECTED TO GENERATE INPUTS
		const selectedOption = tagTypeSelect.options[tagTypeSelect.selectedIndex];
		const contactInputs = JSON.parse(selectedOption.dataset.contactInputs);

		this.handleTagSelection(selectedOption);

		return contactInputs;
	},

	setCardText(selectedTagText) {
		const {infoTipCard, cardTextFallback} = this;

		//IF INFO CARD TEXT SET FROM CMS, USE THAT, ELSE USE STATIC
		const qrInfoTipText = selectedTagText || cardTextFallback[value];
		infoTipCard.innerText = qrInfoTipText;
	},

}








//HANDLES FUNCTIONALITY FOR PDF GERNERATION

const lostLuggagePDFBuilder = {
	listTextFallback: ["Scan QR code to view owner's details", "safely return the item to its owner"],
	listText: [],
	tagInputValue: null,

	customStyles: {
		luggage: {
			containerStyles: {gap: 67, paddingTop: 185, paddingRight: 54, paddingBottom: 60, paddingLeft: 54, width: 1181, height: 591},
			bannerStyles: { fontSize: 50, paddingTop: 25, paddingRight: 60, paddingBottom: 25, paddingLeft: 60, height: 125, borderBottom: 1 },
			qrStyles: {width: 358, height: 358},
			listStyles: {},
			listItemStyles: {fontSize: 42, marginBottom: 34, wordSpacing: 3},
		},
		phone: {
			containerStyles: {gap: 67, paddingTop: 185, paddingRight: 54, paddingBottom: 60, paddingLeft: 54, width: 1063, height: 591},
			bannerStyles: { fontSize: 50, paddingTop: 25, paddingRight: 60, paddingBottom: 25, paddingLeft: 60, height: 125, borderBottom: 1 },
			qrStyles: {width: 358, height: 358},
			listStyles: {},
			listItemStyles: {fontSize: 42, marginBottom: 34, wordSpacing: 3},
		},
		key: {
			containerStyles: {gap: 16, paddingTop: 92, paddingRight:24, paddingBottom: 28, paddingLeft: 24, width: 354, height: 472, flexDirection: "column", alignItems: "flex-start"},
			bannerStyles: {fontSize: 26, paddingTop: 17, paddingRight: 24, paddingBottom: 17, paddingLeft: 24,  height: 68, borderBottom: 1},
			qrStyles: {width: 200, height: 200},
			listStyles: {width: 306, marginLeft: 0, listStylePosition: "inside"},
			listItemStyles: {fontSize: 22, marginBottom: 16, wordSpacing: 3}
		}
	},

	init() {
		const {listText} = this;

		const pdfGeneratorPDFTemplate = document.getElementById('cnsfg-wdgt-lost-luggage-pdf-info');
		const listItems = pdfGeneratorPDFTemplate.querySelectorAll('li');

		listItems.forEach(listItem => listText.push(listItem.innerText));
	},

	createPDFLayout() {
		const {customStyles, tagInputValue} = this;

		const styles = customStyles[tagInputValue];
		if (!styles) return null;

		const {containerStyles, bannerStyles, qrStyles, listStyles, listItemStyles} = customStyles[tagInputValue];

		const pdfContent = this.createContainer(containerStyles);
		if (!pdfContent) return null;

		const qrCodeContainer = this.createQRCode(qrStyles);
		const banner = this.createBanner(bannerStyles);
		const list = this.createPDFList(listStyles, listItemStyles);

		pdfContent.appendChild(banner);
		pdfContent.appendChild(qrCodeContainer);
		pdfContent.appendChild(list);

		return pdfContent;
	},

	createContainer(styles) {
		if (!styles) return null;
		const container = document.createElement('div');
		container.id = 'cnfsd-wdgt-lost-luggage-pdf';
		container.classList.add('pdf-content');

		//	RETURNS NEW CONTAINER ELEMENT WITH CUSTOM STYLES BASED ON SELECTED TAG
		return this.setCustomStyles(container, styles);
	},

	createBanner(styles) {
		const banner = document.createElement('div');
		banner.classList.add('pdf-content__banner');

		const bannerText = document.createElement('b');
		bannerText.innerText = 'Lost item';

		banner.appendChild(bannerText);

		return this.setCustomStyles(banner, styles);
	},

	createPDFList(listStyles, listItemStyles) {
		const {listText, listTextFallback} = this;

		//IF LIST ITEM EXISTS IN CMS, USE THAT ELSE USE FALLBACK
		const listItem = listText.length ? listText : listTextFallback;

		const list = document.createElement('ul');
		listItem.forEach(listItemText => {
			const listItem = document.createElement('li');
			listItem.textContent = listItemText;
			this.setCustomStyles(listItem, listItemStyles);
			list.appendChild(listItem);
		});

		return this.setCustomStyles(list, listStyles);
	},

	createQRCode(styles) {
		const {width, height} = styles;

		const qrCodeContainer = document.createElement('div');
		qrCodeContainer.classList.add('pdf-content__qr-container');

		//CREATE QR CODE FOR PDF
		lostLuggageQRGenerator.generateQRCode(qrCodeContainer, width, height);

		return this.setCustomStyles(qrCodeContainer, styles);
	},


	setCustomStyles(element, styles) {
		Object.entries(styles).forEach(([property, value]) => {
			const pixelAsNumber = parseInt(value, 10);
			if (isNaN(pixelAsNumber)) {
				//IF NOT A NUMBER, SET STYLE PROPERTY
				element.style[property] = value;
			}	else {
				//CONVERT PIXEL VALUE INTO MM FOR PRINTING
				const pixelAsMM = this.convertPixelsToMillimeters(pixelAsNumber);
				element.style[property] = `${pixelAsMM}mm`;
			}
		});

		return element;
	},

	convertPixelsToMillimeters(pixelValue) {
		const dpi = 300;
		const inchesInMM = 25.4;
		const pixelValueInMM = (pixelValue / dpi) * inchesInMM;
		return pixelValueInMM;
	},

	generatePDF(e) {
		e.preventDefault();

		const pdfLayout = this.createPDFLayout();

		if (!pdfLayout) {
			console.error("PDF layout could not be created");
			return;
		};

		// OPTIONS FOR PDF GENERATION
        const options = {
            margin: 5,
            filename: 'Lost-QR-Code.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 1.5, 
            },
            jsPDF: {
                unit: 'mm', 
                format: 'a4',
                orientation: 'portrait', 
            },
		}


		try {
			html2pdf().from(pdfLayout).set(options).save();
		} catch (err) {
			console.error("Error generating or saving the PDF:", err);
		}
	},
}



document.addEventListener('DOMContentLoaded', function () {
	const widgetContainer = document.getElementById('cnfsd-wdgt-lost-luggage');

	if (widgetContainer) {
		widgetControlls.init(widgetContainer);
		lostLuggageQRGenerator.init(widgetContainer);
		lostLuggagePDFBuilder.init();
	}
});